import global from './global'

//elementors
import catalogCarousel from './elementor/catalog-carousel'
import productCarousel from './elementor/product-carousel'

// Pages
import singleProductController from './pages/single-product'
import shopController from './pages/shop'

const controllers = {
  // home: homeController,
  product: singleProductController,
  shop: shopController,
}

const _find = (_class, _str) => {
  if (_class.length > 0) {
    let _array = null
    for (let i = 0; i < _class.length; i++) {
      const n = _class[i].indexOf(_str)
      if (n > 0) {
        _array = _class[i].replace('_' + _str, '')
        break
      }
    }
    return _array
  } else {
    return null
  }
}

const router = () => {
  const _class = document.body.className.replace(/-/g, '_').split(/\s+/)
  const controller = _find(_class, 'stb')
  new global()
  if (controller !== null) {
    if (controllers[controller]) {
      new controllers[controller]()
    }
  }

  //load elementor lib
	jQuery(window).on('elementor/frontend/init', () => {
		catalogCarousel()
    productCarousel()
	})
}
router()
